import type { ProjectRecord } from './projects.types';

export const featuredProjectIds = [
  'incline-creek-estates',
  'country-club-villas',
  'village-plaza-gas-station-site-conversion',
  'golf-course-villas-iv-champ-course',
] as const;

export const featuredProjectOverrides: Record<string, Partial<ProjectRecord>> = {
  'incline-creek-estates': {
    displayTitle: 'Incline Creek Estates',
    description:
      'A residential community in the heart of Incline Village, pairing mountain living with thoughtful planning, smart home features, and durable construction standards.',
    features: [
      '50 residential units across approximately 150,000 sq ft',
      'Smart home technology and custom-finished interiors',
      'LEED-certified insulation and decking',
      'Scott Development role: GP-Developer',
    ],
    image: '/images/ice3_remastered.png',
  },
  'country-club-villas': {
    displayTitle: 'Country Club Villas',
    description:
      'A luxury townhome community adjacent to the Hyatt Regency Lake Tahoe, positioned for walkable access to Incline Village beaches, hospitality, and mountain recreation.',
    features: [
      '50 townhomes across approximately 120,000 sq ft',
      'Three bedroom, 2.5 bath plans averaging approximately 2,100 sq ft',
      'Walking distance to Lake Tahoe beaches',
      'Scott Development role: Broker-Co-Developer',
    ],
    image: '/images/ccv_better.png',
  },
  'village-plaza-gas-station-site-conversion': {
    displayTitle: 'Village Plaza',
    description:
      "A retail and office campus created through a complex gas station site conversion at one of Incline Village's most visible intersections.",
    features: [
      '30,000 sq ft commercial-retail project',
      "Major tenants include Starbucks, Quizno's, and Keva Juice",
      'Gas station conversion and professional office program',
      'Scott Development role: GP-Developer',
    ],
    image: '/images/starbucks_better.png',
  },
  'golf-course-villas-iv-champ-course': {
    displayTitle: 'Incline Championship Golf Course Villas',
    description:
      'A collection of luxury townhomes with custom finish work and a setting shaped around the Championship Golf Course, mountain views, and creek-side context.',
    features: [
      '14 luxury townhomes across approximately 45,000 sq ft',
      'Average 2,200 sq ft with three bedrooms and 2.5 baths',
      'Walkable Championship Golf Course access',
      'Scott Development role: Broker-Co-Developer',
    ],
    image: '/images/gcv_better.png',
  },
};

export const pendingProjectOverrides: Record<string, Partial<ProjectRecord>> = {
  'legacy-club-mccall-id': {
    displayTitle: 'The Legacy Club',
    location: 'Central Idaho',
    eyebrow: 'Qualified Opportunity Zone',
    featureHeading: 'QOZ Focus Areas',
    kind: 'qoz',
    role: 'Developer-Consultant',
    squareFeet: null,
    units: null,
    description:
      'A master-planned sustainable resort and residence club opportunity spanning approximately 40,000 acres in central Idaho.',
    features: [
      'Approximately 40,000 acres in central Idaho',
      'Master-planned sustainable resort and residence club concept',
      'Scott Development role: Developer-Consultant',
      'CEO, Clearwater Resort Holdings, LLC',
      'QOZ strategy and offering details pending confirmation',
    ],
    details: [
      { label: 'Planning focus', value: 'Resort programming, residence club strategy, and land stewardship across central Idaho' },
      { label: 'Current phase', value: 'Master planning, development positioning, and opportunity review' },
      { label: 'Role', value: 'Developer-Consultant' },
      { label: 'Affiliation', value: 'CEO, Clearwater Resort Holdings, LLC' },
    ],
    image: '/images/legacy_club.png',
  },
  // 'chateau-at-the-village': {
  //   eyebrow: 'Qualified Opportunity Zone',
  //   featureHeading: 'QOZ Focus Areas',
  //   kind: 'qoz',
  //   role: 'Developer-Consultant',
  //   description:
  //     'A hotel, condominium, and mixed-use resort opportunity in South Lake Tahoe, positioned around hospitality programming and destination-scale entitlement strategy.',
  //   features: [
  //     'Hotel, condominium, mixed-use resort program',
  //     'Approximately 200,000 sq ft with 387 units',
  //     'South Lake Tahoe resort-market positioning',
  //     'Scott Development role: Developer-Consultant',
  //     'CEO, Clearwater Resort Holdings, LLC',
  //   ],
  //   details: [
  //     { label: 'Planning focus', value: 'Hotel, condominium, mixed-use resort positioning' },
  //     { label: 'Current phase', value: 'Pending project materials and entitlement strategy' },
  //     { label: 'Role', value: 'Developer-Consultant' },
  //     { label: 'Affiliation', value: 'CEO, Clearwater Resort Holdings, LLC' },
  //   ],
  //   image: '/images/chateau.png',
  //   imagePosition: '72% center',
  // },
};

export const additionalPendingProjects: ProjectRecord[] = [
  {
    id: 'grand-tahoe-blue-resort-residence-club',
    title: 'Grand Tahoe Blue Resort & Residence Club',
    type: 'Resort and Residence Club',
    typeCategory: 'hotel',
    squareFeet: null,
    units: null,
    role: 'Development strategy',
    location: 'Lake Tahoe Basin',
    status: 'pending',
    eyebrow: 'Qualified Opportunity Zone',
    featureHeading: 'QOZ Focus Areas',
    kind: 'qoz',
    description:
      'A pending resort and residence club opportunity envisioned for the Lake Tahoe market, with a focus on sustainable master planning, hospitality programming, and Qualified Opportunity Zone-aligned capital strategy.',
    features: [
      'Resort, hospitality, and residence club concept',
      'QOZ-focused funding strategy subject to diligence',
      'Sustainable infrastructure and entitlement planning',
      'Detailed opportunity materials to be finalized',
    ],
    details: [
      { label: 'Planning focus', value: 'Hospitality, residence club, and sustainable resort infrastructure' },
      { label: 'Current phase', value: 'Opportunity materials, diligence, and entitlement strategy in progress' },
      { label: 'Capital approach', value: 'Structured for QOZ review, subject to investor and regulatory diligence' },
    ],
    image: '/images/grand_tahoe_blue.png',
  },
];
